import { extend } from 'elemental-react';
import BaseButton from './BaseButton';
var DefaultButton = extend(BaseButton, function () { return ({
    color: 'black',
    ':hover': {
        bg: '#FFCF60',
    },
}); });
export default DefaultButton;
